/**
 * Role color palette — the app-wide convention for coloring cards /
 * bars / tiles by functional role. Consistency reads blue, Interaction
 * red (matches the seared accent), Efficiency gold (the other accent),
 * Win Conditions green.
 *
 * Keep in sync with CHART_ROLE_COLORS in `chartTheme.jsx` — the chart
 * module re-exports from here so there's a single source of truth.
 */

export const ROLE_ORDER = ['consistency', 'interaction', 'efficiency', 'winConditions'];

export const ROLE_COLORS = {
    consistency: '#4a9bd6',
    interaction: '#cc1a1a',
    efficiency: '#e8c600',
    winConditions: '#5fa85a',
};

export const DEFAULT_ROLE_COLOR = '#8b93a7';

export const roleColor = (key) => ROLE_COLORS[key] || DEFAULT_ROLE_COLOR;
